import React, { useState } from 'react';
import care from '../img/contact.png';

const Contact = () => {
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    email: '',
    subject: '',
  });

  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const { fname, lname, email, subject } = formData;

    if (!fname || !lname || !email || !subject) {
      setMessage('❌ All fields are required!');
      return false;
    }

    // ✅ Email validation added
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage('❌ Enter a valid email address!');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    setMessage('');

    try {
      const response = await fetch('http://localhost/submit.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        setMessage('✅ Form submitted successfully!');
        setFormData({ fname: '', lname: '', email: '', subject: '' });
      } else {
        setMessage('❌ Submission failed. Try again.');
      }
    } catch (error) {
      setMessage('⚠️ Error connecting to server.');
    }

    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section className="Contact-Us" id="Contact-Us">

      
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "JRP Soft Tech Contact",
          "description": "Contact JRP Soft Tech for website development, mobile app development, CRM, ERP, SaaS and AI solutions."
        })}
      </script>

      <h2>Contact<span style={{ color: 'tomato' }}> Us</span></h2>
      <p className="section-desc">
        Want a website, mobile app, CRM, ERP or SaaS solution? Contact us.
      </p>

      <div className="row">
        <div className="column">
          <img 
            src={care} 
            alt="Contact JRP Soft Tech for website, app and software development services" 
          />
        </div>

        <div className="column">
          <div className="info">
          
            {message && (
              <p style={{ color: message.includes('✅') ? 'green' : 'red' }}>
                {message}
              </p>
            )}
            {/*
            <form onSubmit={handleSubmit}>
              <label htmlFor="fname">First Name:</label>
              <input 
                type="text" 
                id="fname" 
                name="fname" 
                placeholder="Your name.." 
                value={formData.fname} 
                onChange={handleChange} 
              />
              <br /><br />

              <label htmlFor="lname">Last Name:</label>
              <input 
                type="text" 
                id="lname" 
                name="lname" 
                placeholder="Your last name.." 
                value={formData.lname} 
                onChange={handleChange} 
              />
              <br /><br />

              <label htmlFor="email">Email:</label>
              <input 
                type="email"   // ✅ improved type
                id="email" 
                name="email" 
                placeholder="Your email.." 
                value={formData.email} 
                onChange={handleChange} 
              />
              <br /><br />

              <label htmlFor="subject">Subject:</label>
              <textarea 
                id="subject" 
                name="subject" 
                placeholder="Write something.." 
                style={{ height: '80px' }} 
                value={formData.subject} 
                onChange={handleChange}
              ></textarea>
              <br /><br />

              <input 
                type="submit" 
                value={loading ? "Sending..." : "Submit"} 
                disabled={loading}
              />
            </form>*/}
          </div>
          

          <div className="btn">
            <button className="primary-btn btn">
              <a 
                href="https://wa.me/917977874412" 
                style={{ textDecoration: 'none', color: 'white' }}
              >
                BOOK Appointment
              </a>
            </button>

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            <button className="primary-btn btn">
              <a 
                href="https://jrpsofttech.com/contact/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'white' }}
              >
                Contact-Us
              </a>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;